import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Home | Robin Lange",
    },
    children: [
      {
        path: "",
        name: "HomePageContent",
        component: () => import("@/components/HomePage"),
      },
    ],
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: {
      title: "About | Robin Lange",
    },
  },
  {
    path: "/blog",
    name: "Blog",
    component: () => import("@/components/BlogPosts"),
    meta: {
      title: "Blog | Robin Lange",
    },
  },
  {
    path: "/services",
    name: "Services",
    component: () => import("@/components/ServicesPage"),
    meta: {
      title: "Services | Robin Lange",
    },
  },
  {
    path: "/contact",
    name: "Contact Us",
    component: () => import("@/components/ContactPage"),
    meta: {
      title: "Contact | Robin Lange",
    },
    children: [
      {
        path: "",
        name: "ContactForm",
        component: () => import("@/components/ContactForm"),
      },
      {
        path: "success",
        name: "Success",
        component: () => import("@/components/ContactSuccess"),
        meta: {
          title: "Successfully Submitted! | Robin Lange",
        },
      },
    ],
  },
  {
    path: "/platecalc",
    name: "Plate Calculator",
    component: () => import("@/views/PlateCalcView"),
    meta: {
      title: "Plate Calculator | Robin Lange",
    },
  },
  {
    path: "/bmrcalc",
    name: "BMR Calculator",
    component: () => import("@/views/BMRCalcView"),
    meta: {
      title: "BMR Calculator | Robin Lange",
    },
  },
  {
    path: "/macrocalc",
    name: "Macro Calculator",
    component: () => import("../views/MacroCalcView"),
    meta: {
      title: "Macro Calculator | Robin Lange",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
